<template lang="pug">
b-modal#editExchangeRate(
  ref="editExchangeRate"
  :title="$t('ui.combine.edit_exchange_rate')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.currency')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="currency"
        required
        type="text"
        :dirty="$v.currency.$dirty"
        :error="$v.currency.$error"
        v-model.trim.lazy="$v.currency.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.currency" :name="$t('ui.currency')")
    b-form-group(:label="$t('ui.module')").mb-0
      b-form-select(v-model="searchModule" disabled size="sm")
        option(value="" disabled) {{ $t('message.select_option') }}
        option(value="MEMBER") {{ $t('ui.member') }}
        option(value="OPERATOR") {{ $t('ui.operator') }}
      ValidateResult(:value="$v.searchModule" :name="$t('ui.module')")
    b-form-group(:label="$t('ui.deposit_rate')").mb-0
      DebounceInput(
        size="sm"
        ref="base_rate"
        required
        type="text"
        :dirty="$v.base_rate.$dirty"
        :error="$v.base_rate.$error"
        v-model.trim.lazy="$v.base_rate.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.base_rate" :name="$t('ui.deposit_rate')")
    b-form-group(:label="$t('ui.withdrawal_rate')").mb-0
      DebounceInput(
        size="sm"
        ref="base_rate_w"
        required
        type="text"
        :dirty="$v.base_rate_w.$dirty"
        :error="$v.base_rate_w.$error"
        v-model.trim.lazy="$v.base_rate_w.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.base_rate_w" :name="$t('ui.withdrawal_rate')")
    //- b-form-group(:label="$t('ui.rate_php')").mb-0.d-none
    //-   DebounceInput(
    //-     size="sm"
    //-     ref="currency_rate"
    //-     required
    //-     type="text"
    //-     :dirty="$v.currency_rate.$dirty"
    //-     :error="$v.currency_rate.$error"
    //-     v-model.trim.lazy="$v.currency_rate.$model"
    //-     :disabled="loading"
    //-   )
    //-   ValidateResult(:value="$v.currency_rate" :name="$t('ui.rate_php')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      currency: "",
      searchModule: "",
      base_rate: "",
      base_rate_w: "",
      currency_rate: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: { 
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    currency: {
      required,
      maxLength: maxLength(5)
    },
    searchModule: {
      required
    },
    base_rate: {
      required,
      decimal
    },
    base_rate_w: {
      required,
      decimal
    },
    currency_rate: {
      required,
      decimal
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.exchangeRateOperatorUpdateUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          module: this.searchModule,
          currency: this.currency,
          base_rate: this.base_rate,
          base_rate_w: this.base_rate_w,
          currency_rate: this.currency_rate,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editExchangeRate.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_exchange_rate", this.feedback.status);
                  this.$refs.editExchangeRate.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.currency = this.item.currency;
      this.base_rate = this.item.base_rate;
      this.base_rate_w = this.item.base_rate_w;
      this.searchModule = this.item.module;
      this.currency_rate = 1;
      this.$refs.base_rate.$el.focus();
    }
  }
};
</script>
